"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LogLevel_1 = require("./LogLevel");
/**
 * [[NoOpLogger]] does not log any message.
 */


var NoOpLogger = /*#__PURE__*/function () {
  function NoOpLogger() {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LogLevel_1.default.OFF;

    _classCallCheck(this, NoOpLogger);

    this.level = level;
  }

  _createClass(NoOpLogger, [{
    key: "info",
    value: function info(_msg) {}
  }, {
    key: "warn",
    value: function warn(_msg) {}
  }, {
    key: "error",
    value: function error(_msg) {}
  }, {
    key: "debug",
    value: function debug(debugFunction) {
      if (LogLevel_1.default.DEBUG < this.level) {
        return;
      }

      if (typeof debugFunction !== 'string') {
        debugFunction();
      }
    }
  }, {
    key: "setLogLevel",
    value: function setLogLevel(level) {
      this.level = level;
    }
  }, {
    key: "getLogLevel",
    value: function getLogLevel() {
      return this.level;
    }
  }]);

  return NoOpLogger;
}();

exports.default = NoOpLogger;